// extracted by mini-css-extract-plugin
export default {"title":"Benefit_title__P7v4V","description":"Benefit_description__b5Gcx"};